import React, { useState, useEffect } from 'react';
import { Link,useNavigate} from 'react-router-dom';
import { Panel, PanelHeader, PanelBody } from '../../components/panel/panel.jsx';
import {API_BASE_URL} from "../../apiConfig.jsx";
import axios from 'axios';
import {cleanStr,cleanPass} from '../../comfunc.js';
import {strEncode,strDecode} from '../../encrpt.js';
import DataTable from 'react-data-table-component';
import DatePicker from "react-datepicker";
import { saveAs } from "file-saver";
import * as XLSX from "xlsx";
import Select2 from "../../Select2/select2.js";
import moment from 'moment';


function Skills() {
    const navigate = useNavigate();
	const [userData, setUserData] = useState(null);
	
	
		useEffect(() => {
			const authToken = localStorage.getItem("authToken");
			//console.log("authToken",authToken)
			if (!authToken) {
				localStorage.removeItem("user"); // Clear user data
				navigate(""); // Ensure correct redirection path
			}else{
				const storedUser = JSON.parse(localStorage.getItem("user"));
				//console.log("storedUser",storedUser)
				setUserData(storedUser);
			}
		}, [navigate]);
	
	const [formData, setFormData] = useState({
		n_participants_id: "",
		n_effective_communication: "",
		n_self_esteem: "",
		n_resilence_and_adaptation: "",
		n_decision_making_and_problem_solving: "",
		n_critical_thinking: "",
		n_creative_thinking: "",
		n_time_management :'',
		n_respect_and_diversity :'',
		n_conflict_negotitation :'',
		n_engagement_and_leadership:'',
		n_vocational_training : '',
        d_start_date : '',
		d_end_date :'',
		n_pre_exam : '',
		n_post_exam :'',
		n_conclusion:''
	  });
	  
	
	 const [errors, setErrors] = useState({});
    const [participants, setParticipantsList] = useState([]);	
	 const [participantsprofession, setParticipantsProfessionList] = useState([]);
	 const [gender, setGenderList] = useState([]);
	 const [yesno, setYesNoList] = useState([]);
	 const [internes, setRaporteeList] = useState([]);
	 const [columns, setColumns] = useState([]);
	 const [tabledata, settableData] = useState([]);	
	 const [selectedUser, setSelectedUser] = useState(null);
	  const [vocationaltraining, setSelectedVocationaltraining] = useState([]);
	  const [selectedparticipant, setSelectedParticipant] = useState([]);
     const [editMode, setEditMode] = useState(false);
     const [modalData, setModalData] = useState(false);
     const [activeTab, setActiveTab] = useState("default-tab-1"); // Tracks active tab
     const [indiid, setModalId] = useState(null);	
     const [raporteedata, setRapporteeData] = useState({
	  n_stakeholder_id : ""
      });
  useEffect(() => {
	// Switch to "Ajouter un nouvel utilisateur" tab if edit mode is enabled
	if (editMode) {
	  setActiveTab("default-tab-2");
	//setEditMode(false)
	} else {
	  setActiveTab("default-tab-1");
	}
  }, [editMode]);
  
  useEffect(() => {
	axios.post(`${API_BASE_URL}/api/custom/selectall`, { t: strEncode('pmis_participants_registration')},{ headers: { 'Content-Type': 'application/json' } }) 
    	.then( (res) => {
	    setParticipantsList(res.data);
	    }).catch( (error) => { console.log(error); }); 
  
	 axios.post(`${API_BASE_URL}/api/custom/selectall`, { t: strEncode('pmis_participants_profession_mst')},{ headers: { 'Content-Type': 'application/json' } }) 
	   .then( (res) => {
	   setParticipantsProfessionList(res.data);
	   }).catch( (error) => { console.log(error); });

	axios.post(`${API_BASE_URL}/api/custom/selectall`, { t: strEncode('pmis_participants_vocational_training_mst')},{ headers: { 'Content-Type': 'application/json' } }) 
	   .then( (res) => {
	   setSelectedVocationaltraining(res.data);
	   }).catch( (error) => { console.log(error); });

	  axios.post(`${API_BASE_URL}/api/custom/selectall`, { t: strEncode('pmis_gender_mst')},{ headers: { 'Content-Type': 'application/json' } }) 
	.then( (res) => {
		setGenderList(res.data);
	  }).catch( (error) => { console.log(error); });

	  axios.post(`${API_BASE_URL}/api/custom/selectall`, { t: strEncode('pmis_yes_no_mst')},{ headers: { 'Content-Type': 'application/json' } }) 
	.then( (res) => {
		setYesNoList(res.data);
	  }).catch( (error) => { console.log(error); });

	  axios.post(`${API_BASE_URL}/api/custom/selectall`, { t: strEncode('v_pmis_participants_soft_skills'),cols:strEncode('*') },{ headers: { 'Content-Type': 'application/json' } }) 
				  .then( (res) => {					
					if (!res.data || !res.data || res.data.length === 0) {
						console.warn("Warning: API returned an empty or undefined response.");
						setColumns([]); // Reset columns
						settableData([]); // Reset table data
						return;
					}
					const columnKeys = Object.keys(res.data[0]);
					
					const formattedColumns = columnKeys.map((key) => ({
						name: key.charAt(0).toUpperCase() + key.slice(1),
						selector: row => row[key],
						sortable: true,
						cell: row => row[key] // Show normal column data
					  }));

					  formattedColumns.push({
						name: "Actions",
						cell: (row) => (
							<div>
						  <button className="btn btn-warning btn-sm" onClick={() => handleEdit(row)}>
						  تعديل
						  </button>
						   </div>
						),
					  });
					//console.log("columnKeys",columnKeys)
					setColumns(formattedColumns);
                    settableData(res.data);					
				  }).catch(error => {
					console.error("API Error:", error);
				  });
  }, []);
	
const tabActive = async (user) => {
	setFormData({
			n_participants_id: "",
		n_effective_communication: "",
		n_self_esteem: "",
		n_resilence_and_adaptation: "",
		n_decision_making_and_problem_solving: "",
		n_critical_thinking: "",
		n_creative_thinking: "0",
		n_time_management :'',
		n_respect_and_diversity :'',
		n_conflict_negotitation :'',
		n_engagement_and_leadership:'',
		n_vocational_training : '',
        d_start_date : '',
		d_end_date :'',
		n_pre_exam : '',
		n_post_exam :'',
		n_conclusion:''  });
  
	 setEditMode(false);
	 setSelectedUser(null);
}

const closeModal = () => {
	setModalData([]);
   }


  const handleEdit = async (user) => {
	//console.log("user.id",user.id)
	setSelectedUser(user);
	try {
	  const response = await axios.post(`${API_BASE_URL}/api/custom/selectall`, {
		t: strEncode('pmis_participants_soft_skills'),
		cols : 	strEncode('*'),	
		whrc : strEncode('id = '+user.id+''),
	  }, { headers: { 'Content-Type': 'application/json' } });
  
	 setFormData({
		id : response.data[0].id,
		n_participants_id: response.data[0].n_participants_id,
		n_effective_communication: response.data[0].n_effective_communication,
		n_self_esteem: response.data[0].n_self_esteem,
		n_resilence_and_adaptation: response.data[0].n_resilence_and_adaptation,
		n_decision_making_and_problem_solving: response.data[0].n_decision_making_and_problem_solving,
		n_critical_thinking: response.data[0].n_critical_thinking,
		n_creative_thinking: response.data[0].n_creative_thinking,
		n_time_management :response.data[0].n_time_management,
		n_respect_and_diversity :response.data[0].n_respect_and_diversity,
		n_conflict_negotitation :response.data[0].n_conflict_negotitation,
		n_engagement_and_leadership:response.data[0].n_engagement_and_leadership,
		n_vocational_training : response.data[0].n_vocational_training,
        d_start_date : response.data[0].d_start_date,
		d_end_date : response.data[0].d_end_date,
		n_pre_exam : response.data[0].n_pre_exam,
		n_post_exam :response.data[0].n_post_exam,
		n_conclusion:response.data[0].n_conclusion,
	  });

	} catch (error) {
	  console.error("Error fetching user data:", error);
	}
	setEditMode(true);
	setActiveTab("default-tab-2");
  };
  
   // console.log("usertyoe",usertype)
	  const userstatus = [
		{ id: 0, c_name: "Actif" },
		{ id: 1, c_name: "Inactif" },
	  ];

	  const validateEmail = (email) => {
		const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
		return emailRegex.test(email);
	  };
	
	  const validatePassword = (password) => {
		return {
		  length: password.length >= 12,
		  uppercase: /[A-Z]/.test(password),
		  number: /\d/.test(password),
		  specialChar: /[~_!@#^()-+|.,]/.test(password),
		  restrictedChars: !/[&\/\\$%'"`=:;*?<>{}]/.test(password),
		};
	  };
	
	  	const handleChangeDates = (name, date) => {
			if (!name || !date) return;
		  
			const formattedDate = date ? moment(date).format('YYYY-MM-DD') : '';
			//const change = { [name]: formattedDate };
		  
		   setFormData((prevData) => ({
					...prevData,
					[name]: formattedDate, // Keep existing password if blank
				}));
			//console.log("Date change:", change);
		  };
	
	 /* const handleChange = (e) => {
		const { name, value } = e.target;
		setFormData({ ...formData, [name]: value });
	
		// Validation Logic
		let newErrors = { ...errors };
	
		if (!value) {
		  newErrors[name] = "This field is required.";
		} else {
		  delete newErrors[name];
		}
	
		if (name === "c_email" && !validateEmail(value)) {
		  newErrors[name] = "Invalid email format.";
		}
	
		if (name === "c_password" ) {
		  const validations = validatePassword(value);
		  if (!validations.length) newErrors[name] = "Password must be at least 12 characters.";
		  if (!validations.uppercase) newErrors[name] = "Password must contain at least one uppercase letter.";
		  if (!validations.number) newErrors[name] = "Password must contain at least one number.";
		  if (!validations.specialChar) newErrors[name] = "Password must contain at least one special character.";
		  if (!validations.restrictedChars) newErrors[name] = "Password contains restricted characters.";
		}
	
		setErrors(newErrors);
	  }; */
	

	  const handleChange = (e) => {
		const { name, value } = e.target;
		
		setFormData((prevData) => ({
			...prevData,
			[name]: name === "c_password" && !value ? "" : value, // Keep existing password if blank
		}));
	
		// Validation Logic
		let newErrors = { ...errors };
	
		if (!value) {
			newErrors[name] = "This field is required.";
		} else {
			delete newErrors[name];
		}
	
		if (name === "c_email" && !validateEmail(value)) {
			newErrors[name] = "Invalid email format.";
		}
	
		if (name === "c_password" && value) { // Only validate if password is entered
			const validations = validatePassword(value);
			if (!validations.length) newErrors[name] = "Password must be at least 12 characters.";
			if (!validations.uppercase) newErrors[name] = "Password must contain at least one uppercase letter.";
			if (!validations.number) newErrors[name] = "Password must contain at least one number.";
			if (!validations.specialChar) newErrors[name] = "Password must contain at least one special character.";
			if (!validations.restrictedChars) newErrors[name] = "Password contains restricted characters.";
		}
	
		setErrors(newErrors);
	};

	const handleChangeparticipants = (e) => {
		//console.log("we are here")
		const { name, value } = e.target;
		setFormData((prevData) => ({
			...prevData,
			[name]: value, // Keep existing password if blank
		}));

         axios.post(`${API_BASE_URL}/api/custom/selectall`,
			 { t: strEncode('v_pmis_participants_registration_display'),cols:strEncode('*'),whrc:strEncode('id = "'+e.target.value+'"') },
			 { headers: { 'Content-Type': 'application/json' } }) 
				  .then( (res) => {					
					var data  = res.data
					setSelectedParticipant(data);
					}).catch(error => {
					console.error("API Error:", error);
				  });
	};



	  const handleSubmit = async (e) => {
		e.preventDefault();
	   
		let newErrors = {};
		
		if (!editMode) {
		// If there are validation errors, stop submission
		if (Object.keys(newErrors).length > 0) {
		  setErrors(newErrors);
		  return;
		}
	}
		console.log("formdata",formData)
		try {
		   const payload = {
				data: {
					...formData,
					n_user_id: userData?.id
				}
				};

		  var response;
		  if (!editMode) {
			response = await axios.post(`${API_BASE_URL}/api/participants/softskills`,payload);
			alert("تم حفظ البيانات بنجاح!");
			setEditMode(false);
			setSelectedUser(null);
			window.location.reload(); // Refresh DataTable
		  } else {
			response = await axios.put(`${API_BASE_URL}/api/participants/softskills/update`, { data: formData });
			alert("تم تحديث البيانات بنجاح!");
			setEditMode(false);
			setSelectedUser(null);
			window.location.reload(); // Refresh DataTable
		  }
		   // Reset formData state
		   setFormData({
				n_participants_id: "",
		n_effective_communication: "",
		n_self_esteem: "",
		n_resilence_and_adaptation: "",
		n_decision_making_and_problem_solving: "",
		n_critical_thinking: "",
		n_creative_thinking: "",
		n_time_management :'',
		n_respect_and_diversity :'',
		n_conflict_negotitation :'',
		n_engagement_and_leadership:'',
		n_vocational_training : '',
        d_start_date : '',
		d_end_date :'',
		n_pre_exam : '',
		n_post_exam :'',
		n_conclusion:''
		  });
	  
		 
		} catch (error) {
		  console.error("Error saving data:", error);
		}
	  };

	  

	     const exportData = (type) => {
		 const ws = XLSX.utils.json_to_sheet(tabledata);
		 const wb = XLSX.utils.book_new();
		 XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
	
		 if (type === "csv") {
		  XLSX.writeFile(wb, "data_export.csv");
		} else {
		  XLSX.writeFile(wb, "data_export.xlsx");
		}
	  };
	
	return (
		<div>
			<ol className="breadcrumb float-xl-end">
				<li className="breadcrumb-item"><Link to="/page-option/blank">الصفحة الرئيسية</Link></li>
				<li className="breadcrumb-item"><Link to="/page-option/blank">الإدارة</Link></li>
				<li className="breadcrumb-item active">إدارة المستخدمين</li>
			</ol>
			<h1 className="page-header">الإدارة <small>إنشاء مستخدمين هنا</small></h1>
			<Panel>
				<PanelHeader>إنشاء مستخدمين هنا</PanelHeader>
				<PanelBody>
				<div className="row">
				<div className="col-xl-12">
				<ul className="nav nav-pills">
        <li className="nav-item">
          <a
            href="#default-tab-1"
            data-bs-toggle="tab"
            className={`nav-link ${activeTab === "default-tab-1" ? "active" : ""}`}
            onClick={() => setActiveTab("default-tab-1")}
          >
           <span className="d-sm-block d-none">قائمة</span>
          </a>
        </li>
        <li className="nav-item">
          <a
            href="#default-tab-2"
            data-bs-toggle="tab"
            className={`nav-link ${activeTab === "default-tab-2" ? "active" : ""}`}
            onClick={() => tabActive("default-tab-2")}>
				 <span className="d-sm-block d-none">إضافة مهارات المشاركين الشخصية</span>
            
          </a>
        </li>
      </ul>
					<div className="tab-content panel rounded-0 p-3 m-0">
					<div className={`tab-pane fade ${activeTab === "default-tab-1" ? "active show" : ""}`} id="default-tab-1">
						<button onClick={() => exportData("xlsx")} className="btn btn-success">
								تصدير إلى إكسل
								</button>
							<DataTable
									title="بيانات المستخدم"
									columns={columns}
									data={tabledata}
									pagination
									highlightOnHover
								/>								
						</div>
						<div className={`tab-pane fade ${activeTab === "default-tab-2" ? "active show" : ""}`} id="default-tab-2">
							<form method="post" onSubmit={handleSubmit}>
							<div className="row mb-15px">
									<label className="form-label col-form-label col-md-3">حدد المشارك</label>
									<div className="col-md-9">
										 <Select2 name="n_participants_id"  value={formData.n_participants_id}  onChange={handleChangeparticipants.bind(this)} style={{ width: "100%" }}>
										<option value=''> -- Select -- </option>
										{participants.map(option => {
										return <option value={option.id} key={option.id} >{option.c_name}</option>
										})}
										</Select2>	
									{errors.n_participants_id && <span style={{ color: "red" }}>{errors.n_participants_id}</span>}
									</div>
								</div>										
                                <div>
									{selectedparticipant.map((option) => (
										<table style={{background:"#cecece",borderRadius:"5px"}} className="table table-responsive table-bordered table-striped">
											<tr><td>اسم</td><td>{option.c_name}</td></tr>
											<tr><td>جنس</td><td>{option.n_gender}</td></tr>
											<tr><td>حياة</td><td>{option.n_age}</td></tr>
											<tr><td>هاتف</td><td>{option.n_phone_no}</td></tr>
											<tr><td>مستوى التعليم</td><td>{option.c_academic_achivement}</td></tr>
											<tr><td>الوضع الوظيفي</td><td>{option.c_work}</td></tr>
											<tr><td>الوضع الاقتصادي</td><td>{option.n_economic_status}</td></tr>
											<tr><td>مكان</td><td>{option.c_current_residence}</td></tr>
											<tr><td>الوضع الحالي</td><td>{option.c_current_situation}</td></tr>
											<tr><td>ذوي الاحتياجات الخاصة</td><td>{option.n_special_needs}</td></tr>
										</table>
										))}
								</div>
								
								<div className="row mb-15px">
									<label className="form-label col-form-label col-md-3">التواصل الفعال</label>
									<div className="col-md-9">
									<select name="n_effective_communication" className="form-select" onChange={handleChange} value={formData.n_effective_communication}>
										<option value="">يختار</option>
										{yesno.map((option) => (
										<option value={option.id} key={option.id}>{option.c_name}</option>
										))}
									</select>
									{errors.n_effective_communication && <span style={{ color: "red" }}>{errors.n_effective_communication}</span>}
									</div>
								</div>

								<div className="row mb-15px">
									<label className="form-label col-form-label col-md-3">تقدير الذات</label>
									<div className="col-md-9">
									<select name="n_self_esteem" className="form-select" onChange={handleChange} value={formData.n_self_esteem}>
										<option value="">يختار</option>
										{yesno.map((option) => (
										<option value={option.id} key={option.id}>{option.c_name}</option>
										))}
									</select>
									{errors.n_self_esteem && <span style={{ color: "red" }}>{errors.n_self_esteem}</span>}
									</div>
								</div>
								

								<div className="row mb-15px">
									<label className="form-label col-form-label col-md-3">الصمود والتكيف</label>
									<div className="col-md-9">
									<select name="n_resilence_and_adaptation" className="form-select" onChange={handleChange} value={formData.n_resilence_and_adaptation}>
										<option value="">يختار</option>
										{yesno.map((option) => (
										<option value={option.id} key={option.id}>{option.c_name}</option>
										))}
									</select>
									{errors.n_resilence_and_adaptation && <span style={{ color: "red" }}>{errors.n_resilence_and_adaptation}</span>}
									</div>
								</div>
								


								<div className="row mb-15px">
									<label className="form-label col-form-label col-md-3">أتخاذ القرار وحل المشكلات</label>
									<div className="col-md-9">
									<select name="n_decision_making_and_problem_solving" className="form-select" onChange={handleChange} value={formData.n_decision_making_and_problem_solving}>
										<option value="">يختار</option>
										{yesno.map((option) => (
										<option value={option.id} key={option.id}>{option.c_name}</option>
										))}
									</select>
									{errors.n_decision_making_and_problem_solving && <span style={{ color: "red" }}>{errors.n_decision_making_and_problem_solving}</span>}
									</div>
								</div>

								<div className="row mb-15px">
									<label className="form-label col-form-label col-md-3">التفكير النقدي</label>
									<div className="col-md-9">
									<select name="n_critical_thinking" className="form-select" onChange={handleChange} value={formData.n_critical_thinking}>
										<option value="">يختار</option>
										{yesno.map((option) => (
										<option value={option.id} key={option.id}>{option.c_name}</option>
										))}
									</select>
									{errors.n_critical_thinking && <span style={{ color: "red" }}>{errors.n_critical_thinking}</span>}
									</div>
								</div>
								


								<div className="row mb-15px">
									<label className="form-label col-form-label col-md-3">التفكير بطريقة أبداعية</label>
									<div className="col-md-9">
									<select name="n_creative_thinking" className="form-select" onChange={handleChange} value={formData.n_creative_thinking}>
										<option value="">يختار</option>
										{yesno.map((option) => (
										<option value={option.id} key={option.id}>{option.c_name}</option>
										))}
									</select>
									{errors.n_creative_thinking && <span style={{ color: "red" }}>{errors.n_creative_thinking}</span>}
									</div>
								</div>

								<div className="row mb-15px">
									<label className="form-label col-form-label col-md-3">التعليم الذاتي وادارة الوقت</label>
									<div className="col-md-9">
									<select name="n_time_management" className="form-select" onChange={handleChange} value={formData.n_time_management}>
										<option value="">يختار</option>
										{yesno.map((option) => (
										<option value={option.id} key={option.id}>{option.c_name}</option>
										))}
									</select>
									{errors.n_time_management && <span style={{ color: "red" }}>{errors.n_time_management}</span>}
									</div>
								</div>
								


								<div className="row mb-15px">
									<label className="form-label col-form-label col-md-3">أحترام الاخرين والتنوع</label>
									<div className="col-md-9">
									<select name="n_respect_and_diversity" className="form-select" onChange={handleChange} value={formData.n_respect_and_diversity}>
										<option value="">يختار</option>
										{yesno.map((option) => (
										<option value={option.id} key={option.id}>{option.c_name}</option>
										))}
									</select>
									{errors.n_respect_and_diversity && <span style={{ color: "red" }}>{errors.n_respect_and_diversity}</span>}
									</div>
								</div>
								


								<div className="row mb-15px">
									<label className="form-label col-form-label col-md-3">اداارة النزاع والتفاوض</label>
									<div className="col-md-9">
									<select name="n_conflict_negotitation" className="form-select" onChange={handleChange} value={formData.n_conflict_negotitation}>
										<option value="">يختار</option>
										{yesno.map((option) => (
										<option value={option.id} key={option.id}>{option.c_name}</option>
										))}
									</select>
									{errors.n_conflict_negotitation && <span style={{ color: "red" }}>{errors.n_conflict_negotitation}</span>}
									</div>
								</div>
								


								<div className="row mb-15px">
									<label className="form-label col-form-label col-md-3">المشاركة والقيادة الشخصة</label>
									<div className="col-md-9">
									<select name="n_engagement_and_leadership" className="form-select" onChange={handleChange} value={formData.n_engagement_and_leadership}>
										<option value="">يختار</option>
										{yesno.map((option) => (
										<option value={option.id} key={option.id}>{option.c_name}</option>
										))}
									</select>
									{errors.n_engagement_and_leadership && <span style={{ color: "red" }}>{errors.n_engagement_and_leadership}</span>}
									</div>
								</div>

								<div className="row mb-15px">
									<label className="form-label col-form-label col-md-3">التدريب المهني</label>
									<div className="col-md-9">
									<select name="n_vocational_training" className="form-select" onChange={handleChange} value={formData.n_vocational_training}>
										<option value="">يختار</option>
										{vocationaltraining.map((option) => (
										<option value={option.id} key={option.id}>{option.c_name}</option>
										))}
									</select>
									{errors.n_vocational_training && <span style={{ color: "red" }}>{errors.n_vocational_training}</span>}
									</div>
								</div>

                                  <div className="row mb-15px" key="d_start_date">
									<label className="form-label col-form-label col-md-3">تاريخ البدء</label>
										<div className="col-md-9">
										<DatePicker className="form-control mb-5px"  type="text" name="d_start_date" dateFormat="yyyy-MM-dd"  selected={formData.d_start_date} onChange={(date) => handleChangeDates('d_start_date', date)}  /><b className="tooltip tooltip-bottom-right">Needed to enter the Date</b> 
											{errors.d_start_date && <span style={{ color: "red" }}>{errors.d_start_date}</span>}
										</div>
									</div> 

										<div className="row mb-15px" key="d_end_date">
										<label className="form-label col-form-label col-md-3">تاريخ الانتهاء</label>
											<div className="col-md-9">
											<DatePicker className="form-control mb-5px"  type="text" name="d_end_date" dateFormat="yyyy-MM-dd"  selected={formData.d_end_date} onChange={(date) => handleChangeDates('d_end_date', date)}  /><b className="tooltip tooltip-bottom-right">Needed to enter the Date</b> 
												{errors.d_end_date && <span style={{ color: "red" }}>{errors.d_end_date}</span>}
											</div>
										</div> 

								<div className="row mb-15px" key="c_current_residence">
									<label className="form-label col-form-label col-md-3">الامتحان القبلي</label>
									<div className="col-md-9">
										<input
										className="form-control mb-5px"
										type="number"
										name= "n_pre_exam"
										value={formData.n_pre_exam}
										onChange={handleChange}
										/>
                                     {errors.n_pre_exam && <span style={{ color: "red" }}>{errors.n_pre_exam}</span>}
									</div>
									</div>

									<div className="row mb-15px" key="c_current_residence">
									<label className="form-label col-form-label col-md-3">الامتحان البعدي</label>
									<div className="col-md-9">
										<input
										className="form-control mb-5px"
										type="number"
										name= "n_post_exam"
										value={formData.n_post_exam}
										onChange={handleChange}
										/>
                                     {errors.n_post_exam && <span style={{ color: "red" }}>{errors.n_post_exam}</span>}
									</div>
									</div>


									<div className="row mb-15px" key="c_current_residence">
									<label className="form-label col-form-label col-md-3">النتيجة</label>
									<div className="col-md-9">
										<input
										className="form-control mb-5px"
										type="number"
										name= "n_conclusion"
										value={formData.n_conclusion}
										onChange={handleChange}
										/>
                                     {errors.n_conclusion && <span style={{ color: "red" }}>{errors.n_conclusion}</span>}
									</div>
									</div>


                                 {!editMode ?
								<button type="submit"  className="btn btn-success w-100px">يحفظ</button>
								:
								<button type="submit" className="btn btn-success w-100px">تحديث</button> }
								</form>
						</div>
						
					</div>
					</div>
					
					</div>
				</PanelBody>
			</Panel>
		
		</div>
	)
}

export default Skills;